import axios from "axios";

export async function GetAffiche(type) { 

     try {
         const response = await axios.get(`https://api.competition.cleges.com/api/v1/competitions/getAffichage/${type}`)
         return response;
 
     }catch(error){
         return error?.response
     }
   } 
